import type { Middleware } from '@reduxjs/toolkit';

import { clearFullHeadMPRSession } from '@/shared/graphics/medicalImageRender/MedicalImageRender';
import { resetState } from '@/shared/model';

import {
  cancelToothBasisSeriesTasks,
  clearFullHeadMprSavedViewTiles,
  clearToothBasisSeriesEntries,
  clearToothBasisSliceZoomEntries,
} from '@/widgets/FullHeadMPR';

export const fullHeadMprSessionMiddleware: Middleware =
  () => (next) => (action) => {
    if (
      resetState.match(action) ||
      action.type?.endsWith('/logout/fulfilled')
    ) {
      cancelToothBasisSeriesTasks();
      clearFullHeadMPRSession();
      clearToothBasisSeriesEntries();
      clearToothBasisSliceZoomEntries();
      clearFullHeadMprSavedViewTiles();
    }
    return next(action);
  };
